export const formatDateTime = (dateString?: string | null): string => {
    if (!dateString) {return "";}

    const date = new Date(dateString);
    if (isNaN(date.getTime())) {return "";}

    const pad = (n: number) => n.toString().padStart(2, "0");

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = date.getFullYear();

    const hour24 = date.getHours();
    const minutes = pad(date.getMinutes());
    const ampm = hour24 >= 12 ? "pm" : "am";

    return `${day}/${month}/${year} ${pad(hour24)}:${minutes}${ampm}`;
};